import { VueModule } from '@Foundation';
import ArticlePushV2 from './code/Scripts/components/article-push-v2';

export default VueModule({
  components: {
    ArticlePushV2
  }
});
